




































































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import IconExit from '../assets/icon-exit.svg';
import {ITicket, TicketStore} from '@/store/modules/ticket.store';
import {LocationStore} from '@/store/modules/location.store';
import {WebService} from '@/services/web.service';
import {VueMaskFilter} from 'v-mask';
import {conformToMask} from 'text-mask-core';
import { OverlayShowTime } from '@/constants';
import BadgePicker from '@/components/BadgePicker.vue';
// @ is an alias to /src

@Component({
	components: {
		IconExit,
		'badge-picker': BadgePicker
	}
})
export default class WaitlistOverlay extends Vue {
	@Prop({default: null})
	ticketId!: string | null;

	partySizeCustom = false;
	partySizeOptions = [1, 2, 3, 4, 5];
	partySize = 2;

	waitTimeOptions = [2, 5, 10, 15, 20, 30, 45, 60];
	waitTime = 5;

	customerId: string | null = null;
	customerPhone = '';
	customerPhoneFocused = false;
	customerName = '';
	orderNotes = '';

	showOverlayWrapper = false;

	showOverlay = false;
	overlayColor = 'green';
	overlayMessage = '';

	showLoading = false;

	showBadgePicker = false;
	customers = [];

	dataLoaded = false;

	get currentlyWaiting() {
		return TicketStore.currentlyWaiting;
	}


	get quickNotes() {
		return LocationStore.defaultOrderNotes;
	}

	get ticket() {
		if(this.ticketId === null) {
			return null;
		}
		return TicketStore.byId(this.ticketId);
	}

	@Watch('ticketId')
	onTicketIdChange() {
		if(this.ticket !== null) {
			this.partySize = this.ticket.partySize;
			if(!(this.partySize in this.partySizeOptions)) {
				this.partySizeCustom = true;
			}
			this.customerId = this.ticket.customer.id;
			this.customerName = this.ticket.customer.name !== null ? this.ticket.customer.name : '';
			if(this.ticket.customer.phone !== null) {
				this.customerPhone = this.ticket.customer.phone;
				console.log(this.customerPhone);
			} else {
				this.customerPhone = '';
			}
			this.orderNotes = this.ticket.orderNotes !== null ? this.ticket.orderNotes : '';
			this.waitTime = (this.ticket.waitTime as number) / 60;
		}
	}

	@Watch('ticket')
	async onTicketChange(currentTicket: ITicket | null, oldTicket: ITicket | null) {
		if(this.dataLoaded) {
			if(oldTicket !== null && currentTicket !== null && oldTicket.modId === currentTicket.modId) {
				// There was no change
				return;
			}
			console.log('Ticket Changed', currentTicket, oldTicket);
			if(currentTicket === null) {
				// The ticket was closed somewhere else
				await this.$bvModal.msgBoxOk( 'This waitlist was canceled on another device.', {
					title: 'Waitlist Canceled',
					centered: true,
					okTitle: 'Ok'
				});
				await this.close();
			} else {
				if(currentTicket.badgeId !== null) {
					await this.$bvModal.msgBoxOk( 'This waitlist was seated and cannot be edited here', {
						title: 'Waitlist Seated',
						centered: true,
						okTitle: 'Ok'
					});
					await this.close();
				} else {
					if(oldTicket !== null) {
						if(currentTicket.state === 'VIEWED' && (oldTicket.state === 'SENT' || oldTicket.state === 'OPEN')) {
							// If they just opened the ticket then don't fire
							return;
						} else if(
							currentTicket.customer.phone === oldTicket.customer.phone &&
							currentTicket.customer.name === oldTicket.customer.name &&
							currentTicket.partySize === oldTicket.partySize &&
							currentTicket.orderNotes === oldTicket.orderNotes &&
							currentTicket.waitTime === oldTicket.waitTime
						) {
							// This can happen if they resend the sms so we need to check if anything actually changed
							return;
						}
					}

					// It was updated somewhere else
					await this.$bvModal.msgBoxOk( 'This waitlist was updated on another device.', {
						title: 'Waitlist Updated',
						centered: true,
						okTitle: 'Ok'
					});
					await this.onTicketIdChange();
				}
			}
		}
	}

	switchToCustomPartySize() {
		this.partySizeCustom = true;
		this.partySize = 1;
	}

	async cancelWaitlist() {
		if(this.ticketId !== null) {
			try {
				this.dataLoaded = false;
				this.showLoading = true;
				await WebService.closeTicket(this.ticketId);
				this.showLoading = false;
				this.overlayColor = 'blue';
				this.overlayMessage = `Waitlist spot canceled`;
				this.showOverlay = true;
				setTimeout(() => {
					this.showOverlay = false;
					this.close();
				}, OverlayShowTime);
			} catch(e) {
				this.showLoading = false;
				console.log(e);
				await this.$bvModal.msgBoxOk('There was a problem canceling your waitlist spot', {
					title: 'Error',
					centered: true,
					okTitle: 'Ok'
				});
			}
		}
	}

	validate() {
		if(this.customerPhone.length !== 10 && this.customerPhone.length !== 11) {
			this.$bvModal.msgBoxOk('You must enter a valid phone number', {
				title: 'Error',
				centered: true,
				okTitle: 'Ok'
			});
			return false;
		}
		return true;
	}

	async addToWaitlist() {
		if(!this.validate()) {
			return;
		}
		try {
			this.showLoading = true;
			this.dataLoaded = false;
			await WebService.createTicket({
				badgeId: null,
				customer: {
					id: this.customerId,
					name: this.customerName,
					phone: (this.customerPhone.startsWith('1') ? '' : '1') + this.customerPhone
				},
				total: 0,
				partySize: this.partySize,
				waitTime: this.waitTime * 60,
				orderNotes: this.orderNotes
			});
			this.showLoading = false;
			this.overlayColor = 'blue';
			this.overlayMessage = `Added to Waitlist!`;
			this.showOverlay = true;
			setTimeout(() => {
				this.showOverlay = false;
				this.close();
			}, OverlayShowTime);
		} catch(e) {
			this.showLoading = false;
			console.log(e);
			await this.$bvModal.msgBoxOk('There was a problem adding to the waitlist', {
				title: 'Error',
				centered: true,
				okTitle: 'Ok'
			});
		}
	}

	async update() {
		if(!this.validate()) {
			return;
		}
		if(this.ticketId !== null) {
			try {
				this.showLoading = true;
				this.dataLoaded = false;
				await WebService.updateTicket(this.ticketId, {
					badgeId: null,
					customer: {
						id: this.customerId,
						name: this.customerName,
						phone: (this.customerPhone.startsWith('1') ? '' : '1') + this.customerPhone
					},
					total: 0,
					partySize: this.partySize,
					waitTime: this.waitTime * 60,
					orderNotes: this.orderNotes
				});
				this.showLoading = false;
				this.overlayColor = 'blue';
				this.overlayMessage = `Waitlist spot updated!`;
				this.showOverlay = true;
				setTimeout(() => {
					this.showOverlay = false;
					this.close();
				}, OverlayShowTime);
			} catch(e) {
				this.showLoading = false;
				console.log(e);
				await this.$bvModal.msgBoxOk('There was a problem updating your waitlist spot', {
					title: 'Error',
					centered: true,
					okTitle: 'Ok'
				});
			}
		}
	}

	async seatImmediately(badgeId: string) {
		try {
			this.showLoading = true;
			this.dataLoaded = false;
			await WebService.createTicket({
				badgeId: badgeId,
				customer: {
					id: this.customerId,
					name: this.customerName,
					phone: (this.customerPhone.startsWith('1') ? '' : '1') + this.customerPhone
				},
				total: 0,
				partySize: this.partySize,
				waitTime: null,
				orderNotes: this.orderNotes
			});
			this.showLoading = false;
			this.overlayColor = 'blue';
			this.overlayMessage = `Seated!`;
			this.showOverlay = true;
			setTimeout(() => {
				this.showOverlay = false;
				this.close();
			}, OverlayShowTime);
		} catch(e) {
			this.showLoading = false;
			console.log(e);
			await this.$bvModal.msgBoxOk('There was a problem seating your customer', {
				title: 'Error',
				centered: true,
				okTitle: 'Ok'
			});
		}
	}

	seatNow() {
		if(!this.validate()) {
			return;
		}
		this.showBadgePicker = true;
	}

	async badgeSelected(badgeId: string) {
		if(this.ticketId) {
			try {
				this.showLoading = true;
				this.dataLoaded = false;
				await WebService.seatWaitlist(this.ticketId, badgeId);
				this.showLoading = false;
				this.overlayColor = 'blue';
				this.overlayMessage = `Customer Seated!`;
				this.showOverlay = true;
				setTimeout(() => {
					this.showOverlay = false;
					this.close();
				}, OverlayShowTime);
			} catch(e) {
				this.showLoading = false;
				console.log(e);
				await this.$bvModal.msgBoxOk('There was a problem seating your waitlist spot', {
					title: 'Error',
					centered: true,
					okTitle: 'Ok'
				});
			}
		} else {
			await this.seatImmediately(badgeId);
		}
	}

	close() {
		this.showOverlayWrapper = false;
	}

	finalClose() {
		this.$emit('close');
	}

	created() {
		this.onTicketIdChange();
	}

	mounted() {
		if(this.ticketId === null) {
			this.customerPhoneFocused = true;
		}
		this.dataLoaded = true;
	}

	@Watch('customerPhone')
	onCustomerPhoneChange() {
		// If the number changes and it's not one we know then wipe the ID
		if(this.ticket && this.ticket.customer.phone !== this.customerPhone) {
			this.customerId = null;
		}

	}

	customerSelected(data: any) {
		console.log('Customer Selected', data);
		if(this.customerName.trim() === '') {
			this.customerName = data.name;
		}
		this.customerId = data.id;
	}
}
